import clsx from "clsx"
import type { LegacyRef } from "react"
import { forwardRef, useId } from "react"
import styles from './auth.module.scss'

type Props = React.ComponentProps<"textarea"> & {
    addon?: React.ReactNode
    error?: string
    placeholder: string
    floatingInput?: boolean;
}
function Component({ addon, error, className, placeholder, floatingInput = true, ...inputProps }: Props, ref: LegacyRef<HTMLTextAreaElement>) {
    const id = useId()

    const onInput: React.ComponentProps<"textarea">["onInput"] = (e) => {
        //@ts-ignore
        e.target.parentNode.dataset.replicatedValue = e.target.value
    }

    const onFocus = () => {
        if (window.reloadManager)
            window.reloadManager.setReload(0);
    }

    return (
        <div className={clsx("isTextarea", { 'floatingInput': floatingInput }, { "invalid": error }, className)}>
            <div className={styles.inputContainer}>
                <textarea onInput={onInput} onFocus={onFocus} {...inputProps} id={id} ref={ref} placeholder={floatingInput ? " " : placeholder} />
                {floatingInput && <label htmlFor={id}>{placeholder}</label>}
            </div>

            {error && <span className={styles.errorFormTextArea}>{error}</span>}
        </div>
    )
}

export default forwardRef(Component)